import MainLayout from 'layouts/MainLayout';
import { RouteObject, createBrowserRouter } from 'react-router-dom';
import MainLayoutProvider from 'providers/MainLayoutProvider';
import App from 'App';
import CardSignIn from 'pages/authentication/SignIn';
import InstitutionDashboard from 'pages/institutionDashboard/InstitutionDashboard';
import MainLanding from 'pages/landing/Main';
import InstitutionSignUp from 'pages/authentication/register/institution/InstitutionSignUp';
import InstitutionForm from 'components/modules/auth/InstitutionSignUpForm/form/Form';
import CandidateDashboard from 'pages/candidateDashboard/CandidateDashboard';
import AdminDashboard from 'pages/adminDashboard/AdminDashboard';
import RecruiterDashboard from 'pages/recruiterDashboard/RecruiterDashboard';
import InstitutionRouteHandler from 'handler/InstitutionRouteHandler';
import CandidateRouteHandler from 'handler/CandidateRouteHandler';
import AdminRouteHandler from 'handler/AdminRouteHandler';
import RecruiterRouteHandler from 'handler/RecruiterRouteHandler';
import InstitutionStudents from 'pages/institutionStudents/InstitutionStudents';
import AddStudent from 'pages/institutionStudents/addStudent/AddStudent';
import StudentAction from 'pages/institutionStudents/studentAction/StudentAction';
import BulkStudentUpload from 'pages/institutionStudents/bulkUpload/BulkStudentUpload';
import InstitutionStudentSignUp from 'pages/authentication/register/institution/InstitutionStudentSignUp';
import Profile from 'pages/profile/Profile';
import ProfileView from 'pages/profile/view/ProfileView';
import ProfileEdit from 'pages/profile/edit/ProfileEdit';
import ProfilePasswordReset from 'pages/profile/reset/ProfilePasswordReset';
import Quizzes from 'pages/quizzes/Quizzes';
import AssessmentLayout from 'layouts/AssessmentLayout';
import AssessmentLayoutProvider from 'providers/AssessmentLayoutProvider';
import CandidateAssessmentRouteHandler from 'handler/CandidateAssessmentRouteHandler';
import QuizCenter from 'pages/quizCenter/QuizCenter';
import QuizPermissionRequest from 'pages/quizPermissionRequest/QuizPermissionRequest';
import PermissionHandler from 'handler/PermissionHandler';
import VerificationSent from 'pages/verification/verificationSent/VerificationSent';
import InstitutionEmailConfirmation from 'pages/verification/emailConfirmation/institution/InstitutionEmailConfirmation';
import WelcomeStudent from 'pages/landing/student/WelcomeStudent';
import WelcomeRecruiter from 'pages/landing/recruiter/WelcomeRecruiter';
import WelcomeInstitution from 'pages/landing/institution/WelcomeInstitution';
import QuizHeader from 'pages/quizCenter/header/QuizHeader';
import LogicChallengeHeader from 'pages/logicChallenge/header/LogicChallengeHeader';
import LogicChallengeExplorer from 'pages/logicChallenge/explorer/LogicChallengeExplorer';
import LogicChallengeRun from 'pages/logicChallenge/run/LogicChallengeRun';
import StudentEmailConfirmation from 'pages/verification/emailConfirmation/student/StudentEmailConfirmation';
import RecruiterSignUp from 'pages/authentication/register/recruiter/RecruiterSignUp';
import RecruiterForm from 'components/modules/auth/RecruiterSignUpForm/form/Form';
import RecruiterEmailConfirmation from 'pages/verification/emailConfirmation/recruiter/RecruiterEmailConfirmation';
import SearchCandidate from 'pages/search/SearchCandidate';
import SearchCandidateFallback from 'pages/search/fallback/SearchCandidateFallback';
import CandidateOverview from 'pages/search/candidateOverview/CandidateOverview';
import Career from 'pages/career/Career';
import CareerRouteHandler from 'handler/CareerRouteHandler';
import CandidateJobs from 'pages/candidateJobs/CandidateJobs';
import AddJobPost from 'pages/job/add/AddJobPost';
import JobPostAction from 'pages/job/add/action/JobPostAction';
import JobPostView from 'pages/job/view/JobPostView';
import AboutUsPage from 'pages/landing/default/AboutUsPage/AboutUsPage';
import ContactUsPage from 'pages/landing/default/ContactUsPage/ContactUsPage';
import ForgotPassword from 'pages/authentication/ForgetPassword/ForgotPassword';
import ResetPassword from 'pages/authentication/ForgetPassword/ResetPassword/ResetPassword';
import Users from 'pages/users/Users';
import UserInvite from 'pages/authentication/Invite/UserInvite';

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
        path: '/',
        element: <MainLanding />
      },
      {
        path: '/about',
        element: <AboutUsPage />
      },
      {
        path: '/contact',
        element: <ContactUsPage />
      },
      {
        path: '/welcome',
        children: [
          {
            path: 'student',
            element: <WelcomeStudent />
          },
          {
            path: 'recruiter',
            element: <WelcomeRecruiter />
          },
          {
            path: 'institution',
            element: <WelcomeInstitution />
          }
        ]
      },
      {
        path: '/sign-in',
        element: <CardSignIn />
      },
      {
        path: '/forgot-password',
        element: <ForgotPassword />
      },
      {
        path: '/reset-password',
        element: <ResetPassword />
      },
      {
        path: '/invite',
        element: <UserInvite />
      },
      {
        path: '/register',
        children: [
          {
            path: 'institution',
            element: <InstitutionSignUp />,
            children: [
              {
                path: 'basic',
                element: <InstitutionForm mode="institution" />
              },
              {
                path: 'contact',
                element: <InstitutionForm mode="contact" />
              },
              {
                path: 'verify',
                element: <InstitutionForm mode="verify" />
              }
            ]
          },
          {
            path: 'institution-student/:id',
            element: <InstitutionStudentSignUp />
          },
          {
            path: 'recruiter',
            element: <RecruiterSignUp />,
            children: [
              {
                path: 'basic',
                element: <RecruiterForm mode="company" />
              },
              {
                path: 'contact',
                element: <RecruiterForm mode="contact" />
              },
              {
                path: 'verify',
                element: <RecruiterForm mode="verify" />
              }
            ]
          }
        ]
      },
      {
        path: '/verify',
        children: [
          {
            path: 'sent',
            children: [
              {
                path: 'institution/:id',
                element: <VerificationSent />
              },
              {
                path: 'student/:id',
                element: <VerificationSent />
              },
              {
                path: 'recruiter/:id',
                element: <VerificationSent />
              }
            ]
          },
          {
            path: 'institution',
            element: <InstitutionEmailConfirmation />
          },
          {
            path: 'student',
            element: <StudentEmailConfirmation />
          },
          {
            path: 'recruiter',
            element: <RecruiterEmailConfirmation />
          }
        ]
      },
      {
        path: '/',
        element: (
          <MainLayoutProvider>
            <MainLayout />
          </MainLayoutProvider>
        ),
        children: [
          {
            path: 'hub',
            element: <InstitutionRouteHandler />,
            children: [
              // For Institution UserType
              {
                path: 'dashboard',
                element: <InstitutionDashboard />
              },
              {
                path: 'students',
                element: <InstitutionStudents />
              },
              {
                path: 'students/add',
                element: <AddStudent mode="add" />
              },
              {
                path: 'students/bulk',
                element: <BulkStudentUpload />
              },
              {
                path: 'students/:type/:id',
                element: <StudentAction />
              },
              {
                path: 'users',
                element: <Users />
              },
              {
                path: 'profile',
                element: <Profile mode="institution" />,
                children: [
                  {
                    path: 'view',
                    element: <ProfileView mode="institution" />
                  },
                  {
                    path: 'reset-password',
                    element: <ProfilePasswordReset mode="institution" />
                  },
                  {
                    path: 'edit',
                    element: <ProfileEdit mode="institution" />
                  }
                ]
              }
            ]
          },
          {
            path: 'home',
            element: <CandidateRouteHandler />,
            children: [
              // For Candidate UserType
              {
                path: 'dashboard',
                element: <CandidateDashboard />
              },
              {
                path: 'ladder',
                element: <CandidateAssessmentRouteHandler />,
                children: [
                  {
                    path: 'basic',
                    element: <Quizzes />
                  }
                ]
              },
              {
                path: 'jobs',
                element: <CandidateJobs />
              },
              {
                path: 'profile',
                element: <Profile mode="candidate" />,
                children: [
                  {
                    path: 'view',
                    element: <ProfileView mode="candidate" />
                  },
                  {
                    path: 'reset-password',
                    element: <ProfilePasswordReset mode="candidate" />
                  },
                  {
                    path: 'edit',
                    element: <ProfileEdit mode="candidate" />
                  }
                ]
              }
            ]
          },
          {
            path: 'center',
            element: <AdminRouteHandler />,
            children: [
              // For Admin UserType
              {
                path: 'dashboard',
                element: <AdminDashboard />
              }
            ]
          },
          {
            path: 'panel',
            element: <RecruiterRouteHandler />,
            children: [
              // For Recruiter UserType
              {
                path: 'dashboard',
                element: <RecruiterDashboard />
              },
              {
                path: 'recruitment',
                children: [
                  {
                    path: 'search',
                    element: <SearchCandidate />,
                    children: [
                      {
                        index: true,
                        element: <SearchCandidateFallback />
                      },
                      {
                        path: ':search',
                        element: <CandidateOverview />
                      }
                    ]
                  },
                  {
                    path: 'careers',
                    element: <CareerRouteHandler />,
                    children: [
                      {
                        path: 'jobs',
                        element: <Career type="jobs" />
                      },
                      {
                        path: 'internships',
                        element: <Career type="internships" />
                      },
                      {
                        path: 'jobs/add',
                        element: <AddJobPost mode="add" type="post" />
                      },
                      {
                        path: ':type/:mode/:id',
                        element: <JobPostAction />
                      },
                      {
                        path: 'internships/add',
                        element: <AddJobPost mode="add" type="internship" />
                      },
                      {
                        path: ':type/view/:id',
                        element: <JobPostView />
                      }
                    ]
                  }
                ]
              },
              {
                path: 'profile',
                element: <Profile mode="recruiter" />,
                children: [
                  {
                    path: 'view',
                    element: <ProfileView mode="recruiter" />
                  },
                  {
                    path: 'reset-password',
                    element: <ProfilePasswordReset mode="recruiter" />
                  },
                  {
                    path: 'edit',
                    element: <ProfileEdit mode="recruiter" />
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: '/assessment',
        element: (
          <AssessmentLayoutProvider>
            <AssessmentLayout />
          </AssessmentLayoutProvider>
        ),
        children: [
          {
            path: 'practice',
            element: <QuizHeader />,
            children: [
              {
                path: 'quiz',
                element: <QuizCenter />
              }
            ]
          },
          {
            path: 'challenge',
            element: <LogicChallengeHeader />,
            children: [
              {
                path: 'logic',
                children: [
                  {
                    path: 'explorer',
                    element: <LogicChallengeExplorer />
                  },
                  {
                    path: 'run',
                    element: <LogicChallengeRun />
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: '/permission',
        element: <PermissionHandler />,
        children: [
          {
            path: 'quiz/:id',
            element: <QuizPermissionRequest />
          }
        ]
      }
    ]
  }
];

export const router = createBrowserRouter(routes);

export default routes;
